const initialState = {
  app: null,
  sidebar: false,
}

export default function signin(state = initialState, action) {

  switch (action.type) {
    default:
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/store/reducers/App.js